import { endOfDay, subDays } from 'date-fns';
import { TaskStatus } from 'shared/enums/task-status.enum';

export const getDefaultDateRange = (taskStatus: TaskStatus | null): [Date | null, Date | null] => {
  const today = new Date();
  switch (taskStatus) {
    case TaskStatus.COMPLETED:
      return [subDays(today, 1), endOfDay(today)];
    default:
      return [null, null];
  }
};
